<template>
  <v-card>
    <v-footer dark class="font-weight-medium" color="#424242">
      <v-col class="text-center" cols="12">
        <strong>rizingson</strong>&nbsp; &copy;{{ new Date().getFullYear() }}
      </v-col>
    </v-footer>
  </v-card>
</template>
<script>
export default {
  name: "AppFooter"
};
</script>
